<template>
  <div class="card mx-auto mb-3">
    <div class="card-body">
      <div class="mb-3">
        <div class="">
          <h4 class="text-nowrap">
            {{ $t("support-title") }}
          </h4>
        </div>
      </div>
      <div class="chat-wrapper mx-2 p-0">
        <div
          v-for="message in messages.messages"
          :key="message.id"
          class="d-flex text-wrap"
        >
          <div
            class="chat-box-wrapper chat-box-wrapper-right"
            v-if="message.from === userId"
          >
            <div>
              <div class="chat-box-right" :style="message.file !== null ? 'display: block !important':''">
                <div>{{ message.message }}</div>
                <div v-if="message.file !== null" class="file-box-right">
                  <div style="display: block !important">
                    <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#e3e3e3"><path d="M720-330q0 104-73 177T470-80q-104 0-177-73t-73-177v-370q0-75 52.5-127.5T400-880q75 0 127.5 52.5T580-700v350q0 46-32 78t-78 32q-46 0-78-32t-32-78v-370h80v370q0 13 8.5 21.5T470-320q13 0 21.5-8.5T500-350v-350q-1-42-29.5-71T400-800q-42 0-71 29t-29 71v370q-1 71 49 120.5T470-160q70 0 119-49.5T640-330v-390h80v390Z"/></svg>
                    <a v-if="token" :href="'/admin-api/v1/suport/file/'+message.id+'?access_token='+ token" target="_blank">{{ message.file.original }}</a>
                  </div>
                </div>  
              </div>
              
              <small class="opacity-6">
                <font-awesome-icon icon="calendar-alt" />{{
                  new Date(parseInt(message.id)) | formatDate
                }}
              </small>
            </div>
          </div>

          <div class="chat-box-wrapper" v-else>
            <div>
              <div class="chat-box" :style="message.file !== null ? 'display: block !important':''"> 
                <div>{{ message.message }}</div>
                <div v-if="message.file !== null" class="file-box">
                  <div style="display: block !important">
                    <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#e3e3e3"><path d="M720-330q0 104-73 177T470-80q-104 0-177-73t-73-177v-370q0-75 52.5-127.5T400-880q75 0 127.5 52.5T580-700v350q0 46-32 78t-78 32q-46 0-78-32t-32-78v-370h80v370q0 13 8.5 21.5T470-320q13 0 21.5-8.5T500-350v-350q-1-42-29.5-71T400-800q-42 0-71 29t-29 71v370q-1 71 49 120.5T470-160q70 0 119-49.5T640-330v-390h80v390Z"/></svg>
                    <a v-if="token" :href="'/admin-api/v1/suport/file/'+message.id+'?access_token='+ token" target="_blank">{{ message.file.original }}</a>
                  </div>
                </div>  
              </div>
              <small class="opacity-6">
                <font-awesome-icon icon="calendar-alt" />
                {{ new Date(parseInt(message.id)) | formatDate }}
              </small>
            </div>
          </div>
        </div>
      </div>
      <div class="bottom-pane row text-center">
        <div class="form-group col-xs-12 col-md-9 col-xl-10">
          <input
            :placeholder="$t('support-placeholder')"
            type="text"
            class="form-control-lg form-control"
            v-model="messageContent"
          />
        </div>
        <div class="form-group col-xs-12 col-md-3 col-xl-2">
          <input
            type="file"
            @change="handleFileUpload"
            accept="application/pdf, image/gif, image/jpeg, image/png"
          />
        </div>
        <div class="form-group col-xs-12 col-md-3 col-xl-2">
          <v-btn
            color="primary"
            class="float-right text-unset"
            @click="submitForm"
            >{{ $t("support-send") }}</v-btn
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import gql from "graphql-tag";
import { mapGetters } from "vuex";
import axios from "axios";

export default {
  name: "SupportPage",
  data() {
    return {
       token: null,
      messages: null,
      messageContent: "",
      pdfFile: null,
    };
  },
  created() {
    this.token = localStorage.getItem("apollo-token");
     console.log("Token v created():", this.token);
  },
  mounted() {
  this.token = localStorage.getItem("apollo-token");
  console.log("Token v mounted():", this.token);
},
  computed: {
    ...mapGetters({
      userId: "user/userId",
    }),
  },
  apollo: {
    messages: {
      query: gql`
        query {
          messages {
            id
            from
            to
            message
            file {
              original
            }
          }
        }
      `,
      update: (data) => data,
    },
  },
  methods: {
    handleFileUpload(event) {
      const file = event.target.files[0];
      const maxSizeMB = 50;
      const maxSizeBytes = maxSizeMB * 1024 * 1024;


      const data = ["application/pdf", "image/gif", "image/jpeg", "image/png"];

      if (!file) return;


      const element = data.find(v => v===file.type);

      if (!element) {
        alert("Select valid file type.");
        this.pdfFile = null;
        return;
      }

      if (file.size > maxSizeBytes) {
        alert("Datoteka je prevelika. Največja dovoljena velikost je 50 MB.");
        this.pdfFile = null;
        return;
      }

      this.pdfFile = file;
    },

    async submitForm() {
      var token = localStorage.getItem("apollo-token");
      const formData = new FormData();
      formData.append("file", this.pdfFile);
      formData.append("message", this.messageContent);

      try {
        var response = await axios
          .post(
            "/admin-api/v1/submit/message?access_token=" + token,
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
              },
              onUploadProgress: (progressEvent) => {
                const percent = Math.round(
                  (progressEvent.loaded * 100) / progressEvent.total
                );
                console.log(`Nalaganje: ${percent}%`);
                // Lahko dodaš tudi indikator napredka v UI
              },
            }
          )
          .then(function (response) {
            console.log(response);
          })
          .catch(function (error) {
            console.log(error);
          });
        this.pdfFile = null;
        this.messageContent = "";
        this.$apollo.queries.messages.refetch();
      } catch (error) {
        console.error("Napaka:", error);
        alert("Napaka pri pošiljanju.");
      }
    },

    sendMessage() {
      console.log("Sending message " + this.messageContent);
      this.$apollo
        .mutate({
          mutation: gql`
            mutation ($message: String!) {
              submitMessage(message: $message)
            }
          `,
          variables: {
            message: this.messageContent,
          },
        })
        .then(() => {
          this.messageContent = "";
          this.$apollo.queries.messages.refetch();
        });
    },
  },
};
</script>

<style scoped>
.chat-box-wrapper-right {
  justify-content: flex-end;
}

.chat-box-right {
  -webkit-box-shadow: 0 0 0 transparent;
  box-shadow: 0 0 0 transparent;
  position: relative;
  opacity: 1;
  background: #d1ffd2;
  border: 0;
  padding: 0.5rem 1rem;
  border-radius: 30px;
  border-bottom-right-radius: 0.25rem;
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  max-width: 50%;
  min-width: 100%;
  text-align: left;
}

.file-box-right {
  display: block !important
}
.file-box-left {
  display: block !important
}

.link-button {
  background: none;
  border: none;
  padding: 0;
  color: blue; /* ali katera koli barva povezave, ki jo želite */
  text-decoration: underline;
  cursor: pointer;
  font-family: inherit; /* Da podeduje font od nadrejenega elementa */
  font-size: inherit; /* Da podeduje velikost pisave */
}

.link-button:hover {
  color: darkblue; /* ali katera koli barva, ki jo želite ob prehodu z miško */
}
</style>